import React, { Component } from 'react';
import { Button, Card, CardBody, CardGroup, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {  setValues } from '../../store/actions/userActions';

const user = {
	name : '',
	display_name : '',
	phone : '',
	Password : '',
	email : '',
};


class Register extends Component {

	componentWillMount () {
		if(localStorage.getItem('user')){
			this.props.history.push('/dashboard')
		}
	}

    has = (field) => {
        if (this.props.errors.errors.hasOwnProperty(field)) {
            return true;
        } else {
            return false;
        }
    }

    get = (field) => {
        if(this.props.errors.hasOwnProperty(field)){
            return this.props.errors[field][0];
        }
	}
	
  	render() {
		return <div className="app flex-row align-items-center">
			<Container>
				<Row className="justify-content-center">
					<Col md="8">
						<CardGroup>
							<Card className="p-4">
								<CardBody>
									<h1>Get Started</h1>
									<p className="text-muted">Fill your information to be part of us</p>

									{ this.has('name') ? (<span className="is-invalid">{ this.get('name') }</span>) : '' }
									<InputGroup className="mb-3">
										<InputGroupAddon addonType="prepend">
											<InputGroupText>
												<i className="icon-user"></i>
											</InputGroupText>
										</InputGroupAddon>
										<Input type="text" className={ this.has('name') ? 'is-invalid' : '' } placeholder="Name" onKeyUp={ (e) => user.name = e.target.value } />
									</InputGroup>

                                    { this.has('display_name') ? (<span className="is-invalid">{ this.get('display_name') }</span>) : '' }
									<InputGroup className="mb-3">
										<InputGroupAddon addonType="prepend">
											<InputGroupText>
												<i className="icon-user"></i>
											</InputGroupText>
										</InputGroupAddon>
										<Input type="text" className={ this.has('display_name') ? 'is-invalid' : '' } placeholder="Display name" onKeyUp={ (e) => user.display_name = e.target.value } />
									</InputGroup>

									{ this.has('phone') ? (<span className="is-invalid">{ this.get('phone') }</span>) : '' }
									<InputGroup className="mb-3">
										<InputGroupAddon addonType="prepend">
										<InputGroupText>@</InputGroupText>
										</InputGroupAddon>
										<Input type="text" name="phone" className={ this.has('phone') ? 'is-invalid' : '' } placeholder="phone" onKeyUp={ (e) => user.phone = e.target.value } />
									</InputGroup>

									{ this.has('password') ? (<span className="is-invalid">{ this.get('password') }</span>) : '' }
									<InputGroup className="mb-4">
										<InputGroupAddon addonType="prepend">
											<InputGroupText>
												<i className="icon-briefcase"></i>
											</InputGroupText>
										</InputGroupAddon>
										<Input type="password" placeholder="Password" className={ this.has('name') ? 'is-invalid' : '' } onKeyUp={ (e) => user.Password = e.target.value } />
									</InputGroup>

									{ this.has('email') ? (<span className="is-invalid">{ this.get('email') }</span>) : '' }
									<InputGroup className="mb-4">
										<InputGroupAddon addonType="prepend">
											<InputGroupText>
												<i className="icon-briefcase"></i>
											</InputGroupText>
										</InputGroupAddon>
										<Input type="email" placeholder="email" className={ this.has('email') ? 'is-invalid' : '' } onKeyUp={ (e) => user.email = e.target.value } />
									</InputGroup>
									
									<Row>
										<Col xs="6">
											<Button color="primary" className="px-4" onClick={ () => this.props.register(user) }>Continue</Button>
										</Col>
									</Row>
								</CardBody>
							</Card>
							<Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
								<CardBody className="text-center">
									<div>
										<h2>Sign up</h2>
										{/*<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
											labore et dolore magna aliqua.</p>*/}
										<Link to="/login"><Button color="primary" className="mt-3" active>Sign in!</Button></Link>
									</div>
								</CardBody>
							</Card>
						</CardGroup>
					</Col>
				</Row>
			</Container>
		</div>
		
  	}
}


const mapStateToProps = (state) => {
	return {
		user: state.user,
		errors: state.errors
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		setValues: (target) => dispatch(setValues(target)),
		//register: (data) => dispatch(register(data))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Register);



// WEBPACK FOOTER //
// ./src/views/Register/Register.js